module.exports = __webpack_public_path__ + "images/site-plan-1-b6419e7b6569caf70331d3087dceeaaa.jpg";